import type { CheckoutReduxStateV2 } from "@app/types/checkout-v2-types";

export const getCartCurrency = (state: CheckoutReduxStateV2) =>
  state.cart.charges.currency;
